export { default } from './UnscoredCategoryPageBackgroundTextureReviewsSection'
